// 지점 데이터는 packages/lib/src/config/branches/ 로 나갔다 (#856).
//
// 단일앱에서는 디렉터리가 하나뿐이라 이 파일도 하나만 남는다. 그래서 지점마다
// 달라지는 내용이 여기 있을 수 없다. 어느 지점 데이터를 쓸지는 package.json 의
// imports 필드가 정한다 — Node·webpack·turbopack 이 전부 기본 지원하므로
// 빌드마다 자기 지점 파일만 번들된다.
export { branchConfig } from "#branch-config";
